// Shared by CoverPageForm (Kansisivu title default) and ReportSidebar
// (PDF/DOCX export + email filenames) — was 4 slightly different inline
// copies of the same regex, already drifted (some stripped the trailing
// "#123" suffix, some didn't). One place now.
//
// Strips:
//  - any "(...)" annotation, anywhere in the name — e.g. "(V2.1)",
//    "(KEHITYS KESKEN, ÄLÄ KÄYTÄ)" — internal/dev/version tags that
//    shouldn't leak into the user-facing title or a downloaded filename.
//  - a trailing "#123" / "2026 #123" copy-number suffix (reports named via
//    "duplicate" get one appended to stay unique).
export function cleanReportName(name) {
  return (name ?? '')
    .replace(/\([^)]*\)/g, '')
    .replace(/\s+(\d{4}\s+)?#\d+\s*$/i, '')
    .replace(/\s+/g, ' ')
    .trim();
}
